/**
 * Security Services Data - ASI Services Matrix
 * Contains the matrix data for ASI security services comparison
 * Services are now columns (horizontal headers)
 * Features are now rows (vertical headers)
 */

export const securityServicesData = {
  // Services are now the columns (horizontal headers)
  services: [
    {
      id: 'premium_managed_services',
      name: 'Premium Managed Services',
      category: 'ASI Services',
      description: 'Comprehensive managed security services'
    },
    {
      id: 'soc_essentials',
      name: 'SOC Essentials',
      category: 'ASI Services', 
      description: 'Essential security operations center services'
    },
    {
      id: 'soc_complete',
      name: 'SOC Complete',
      category: 'ASI Services',
      description: 'Complete security operations center services'
    },
    {
      id: 'security_awareness_program',
      name: 'Security Awareness Program',
      category: 'ASI Services',
      description: 'Comprehensive security awareness training program'
    },
    {
      id: 'essential_8_assessment',
      name: 'Essential 8 Assessment',
      category: 'ASI Services',
      description: 'ACSC Essential 8 security assessment'
    },
    {
      id: 'office_365_security_optimisation',
      name: 'Office 365 Security Optimisation',
      category: 'ASI Services',
      description: 'Microsoft 365 security optimization services'
    },
    {
      id: 'e8_as_a_service',
      name: 'E8 as a Service',
      category: 'ASI Services',
      description: 'Essential 8 implementation as a service'
    },
    {
      id: 'e8_ml1_patch_service',
      name: 'E8 ML1 Patch Service',
      category: 'ASI Services',
      description: 'Essential 8 Maturity Level 1 patching service'
    }
  ],
  // Features are now the rows (vertical headers)
  features: [
    {
      id: 'managed_security_awareness',
      name: 'Managed Security Awareness Program',
      category: 'Security Programs'
    },
    {
      id: 'essential_8_assessment_feature',
      name: 'Essential 8 Assessment',
      category: 'Assessments'
    },
    {
      id: 'microsoft_365_security_optimisation',
      name: 'Microsoft 365 Security Optimisation Assessment',
      category: 'Assessments'
    },
    {
      id: 'patching_applications_e8_ml1',
      name: 'Patching Applications to ACSC E8 ML1 as a Service',
      category: 'E8 Services'
    },
    {
      id: 'patching_os_e8_ml1',
      name: 'Patching Operating Systems to E8 ML1 as a Service',
      category: 'E8 Services'
    },
    {
      id: 'application_control_e8_ml1',
      name: 'Application Control to E8ML1 as a Service',
      category: 'E8 Services'
    },
    {
      id: 'app_control_workstations',
      name: '[1] Application control is implemented on workstations.',
      category: 'Application Control'
    },
    {
      id: 'app_control_profiles',
      name: '[2] Application control is applied to user profiles and temporary folders used by operating systems, web browsers and email clients.',
      category: 'Application Control'
    },
    {
      id: 'app_control_execution',
      name: '[3] Application control restricts the execution of executables, software libraries, scripts, installers, compiled HTML, HTML applications and control panel applets to an organisation-approved set.',
      category: 'Application Control'
    },
    {
      id: 'targeted_response_times',
      name: 'Targeted Response Times (SLA)',
      category: 'Service Level'
    },
    {
      id: 'windows_patching',
      name: 'Microsoft Windows Patching',
      category: 'Patch Management'
    },
    {
      id: 'third_party_patching',
      name: '3rd Party Software Patching',
      category: 'Patch Management'
    },
    {
      id: 'managed_antivirus',
      name: 'Managed Anti-Virus / Anti-Malware',
      category: 'Endpoint Protection'
    },
    {
      id: 'monitoring_alerting',
      name: '24x7 monitoring and alerting of all IT infrastructure',
      category: 'Monitoring'
    },
    {
      id: 'backup_monitoring',
      name: 'Backup Monitoring',
      category: 'Monitoring'
    },
    {
      id: 'azure_tenant_management',
      name: 'Azure Tenant Management',
      category: 'Cloud Management'
    },
    {
      id: 'office_365_tenant_management',
      name: 'Office 365 Tenant Management',
      category: 'Cloud Management'
    },
    {
      id: 'network_firewall_management',
      name: 'Network & Firewall Management',
      category: 'Network Security'
    },
    {
      id: 'unlimited_remote_support',
      name: 'Unlimited Remote Support for supported devices/software',
      category: 'Support Services'
    },
    {
      id: 'unlimited_onsite_support',
      name: 'Unlimited Onsite Support for supported devices/software',
      category: 'Support Services'
    },
    {
      id: 'after_hours_support',
      name: 'After Hours Support',
      category: 'Support Services'
    },
    {
      id: 'email_filtering',
      name: 'Email Filtering',
      category: 'Email Security'
    },
    {
      id: 'it_documentation',
      name: 'IT Documentation',
      category: 'Documentation'
    },
    {
      id: 'asset_management',
      name: 'Asset Management',
      category: 'Asset Management'
    },
    {
      id: 'executive_reporting',
      name: 'Executive Reporting (Monthly)',
      category: 'Reporting'
    },
    {
      id: 'asset_inventory_reporting',
      name: 'Asset & Inventory Management Reporting (Bi-Annual)',
      category: 'Reporting'
    },
    {
      id: 'tech_business_review',
      name: 'Technology Business Review Meetings (Quarterly)',
      category: 'Business Services'
    },
    {
      id: 'dedicated_service_manager',
      name: 'Dedicated Service Delivery Manager',
      category: 'Business Services'
    },
    {
      id: 'itsm_service_desk',
      name: 'ITSM Service Desk',
      category: 'Support Services'
    },
    {
      id: 'regular_onsite_visits',
      name: 'Regular onsite visits',
      category: 'Support Services'
    },
    {
      id: 'asset_configuration_management',
      name: 'Asset and Configuration Management',
      category: 'Asset Management'
    },
    {
      id: 'change_management',
      name: 'Change Management',
      category: 'Process Management'
    },
    {
      id: 'project_delivery_support',
      name: 'Support Project Delivery',
      category: 'Project Services'
    },
    {
      id: 'onpremises_network_management',
      name: 'Management of On-Premises Network, including periodic firmware updates to Firewalls, Switches and Wireless Access Points',
      category: 'Network Management'
    },
    {
      id: 'firmware_updates',
      name: 'Periodic firmware updates to Firewalls, Switches and Wireless Access Points',
      category: 'Network Management'
    },
    {
      id: 'hardware_support',
      name: 'Hardware Support for devices that are covered under manufacturer warranty',
      category: 'Hardware Support'
    },
    {
      id: 'software_support',
      name: 'Software Support for Microsoft Windows and Microsoft Office products that are not End of Life',
      category: 'Software Support'
    },
    {
      id: 'regular_patch_management',
      name: 'Regular Patch Management for Microsoft and supported 3rd party applications) on all IT infrastructure',
      category: 'Patch Management'
    },
    {
      id: 'backup_management',
      name: 'Management of Backup & Backup Testing (both Automated and Manual)',
      category: 'Backup Services'
    },
    {
      id: 'proactive_security',
      name: 'Proactive Information Security services',
      category: 'Security Services'
    },
    {
      id: 'antivirus_monitoring',
      name: 'Anti-Virus/Anti-Malware Monitoring and Management',
      category: 'Endpoint Protection'
    },
    {
      id: 'user_onboard_offboard',
      name: 'User on-board and off board',
      category: 'User Management'
    },
    {
      id: 'backup_testing_management',
      name: 'Management of backups and backup testing',
      category: 'Backup Services'
    },
    {
      id: 'software_licenses',
      name: 'Software license for; Microsoft 365 Business Premium, DattoRMM,Datto Backupify, Darkweb ID',
      category: 'Software Licensing'
    },
    {
      id: 'cloud_platform_management',
      name: 'Management of Cloud Platforms, including Azure and Microsoft 365, including Capacity Planning and periodic cost modelling review to identify areas where savings can be made to monthly Azure spend',
      category: 'Cloud Management'
    },
    {
      id: 'shared_drives_management',
      name: 'Management of Shared Drives',
      category: 'Data Management'
    },
    {
      id: 'proactive_security_advisory',
      name: 'Proactive Information Security services, including advisory related to ACSC and other key security vendor bulletins and prompt actioning of security incidents.',
      category: 'Security Advisory'
    },
    {
      id: 'sophos_mdr_management',
      name: 'Sophos MDR Management',
      category: 'MDR Services'
    },
    {
      id: 'desktop_helpdesk_support',
      name: 'Desktop / Helpdesk support (24/7/365)',
      category: 'Support Services'
    },
    {
      id: 'ongoing_support_maintenance',
      name: 'Ongoing support, management, and maintenance of ICT Infrastructure, and Software environment',
      category: 'Infrastructure Support'
    },
    {
      id: 'adhoc_services',
      name: 'Adhoc services such as onboarding, new builds, or specialist project, etc',
      category: 'Professional Services'
    },
    {
      id: 'threat_monitoring_response',
      name: '24/7 threat monitoring and response',
      category: 'SOC Services'
    },
    {
      id: 'expert_threat_hunting',
      name: 'Expert-led threat hunting',
      category: 'SOC Services'
    },
    {
      id: 'non_sophos_compatible',
      name: 'Compatible with non-Sophos tools',
      category: 'SOC Services'
    },
    {
      id: 'sophos_products_compatible',
      name: 'Compatible with all Sophos Next Gen Products and Central Services',
      category: 'SOC Services'
    },
    {
      id: 'intelligence_briefings',
      name: 'Intelligence briefings',
      category: 'SOC Services'
    },
    {
      id: 'sophos_health_check',
      name: 'Sophos account health check',
      category: 'SOC Services'
    },
    {
      id: 'weekly_monthly_reporting',
      name: 'Weekly and monthly reporting',
      category: 'SOC Services'
    },
    {
      id: 'threat_containment',
      name: 'Threat containment',
      category: 'SOC Services'
    },
    {
      id: 'reports_service_insights',
      name: 'Reports and service insights',
      category: 'SOC Services'
    },
    {
      id: 'flexible_service_tiers',
      name: 'Flexible service tiers and response modes',
      category: 'SOC Services'
    },
    {
      id: 'direct_call_support',
      name: 'Direct call-in support',
      category: 'SOC Services'
    },
    {
      id: 'sophos_x_ops_backed',
      name: 'Backed by Sophos X-Ops',
      category: 'SOC Services'
    },
    {
      id: 'full_incident_response',
      name: 'Full-scale incident response',
      category: 'SOC Complete'
    },
    {
      id: 'breach_protection_warranty',
      name: '$1 Million Breach Protection Warranty',
      category: 'SOC Complete'
    },
    {
      id: 'root_cause_analysis',
      name: 'Root cause analysis',
      category: 'SOC Complete'
    },
    {
      id: 'endpoint_protection_included',
      name: 'Endpoint protection included',
      category: 'SOC Complete'
    },
    {
      id: 'dedicated_ir_lead',
      name: 'Dedicated Incident Response Lead',
      category: 'SOC Complete'
    },
    {
      id: 'sophos_ndr',
      name: 'Sophos NDR (Network Detection and Response)',
      category: 'Optional Add-ons'
    },
    {
      id: 'sophos_managed_risk',
      name: 'Sophos Managed Risk (EASM and IASM)',
      category: 'Optional Add-ons'
    }
  ],
  // Feature-service matrix - mapping which features are included in which services
  // Now structured as feature_id -> service_id -> availability
  featureServices: {
    managed_security_awareness: {
      premium_managed_services: 'Yes',
      security_awareness_program: 'Yes'
    },
    essential_8_assessment_feature: {
      essential_8_assessment: 'Yes'
    },
    microsoft_365_security_optimisation: {
      office_365_security_optimisation: 'Yes'
    },
    patching_applications_e8_ml1: {
      e8_as_a_service: 'Yes',
      e8_ml1_patch_service: 'Yes'
    },
    patching_os_e8_ml1: {
      premium_managed_services: 'Yes',
      e8_ml1_patch_service: 'Yes'
    },
    application_control_e8_ml1: {
      e8_as_a_service: 'Yes'
    },
    app_control_workstations: {
      e8_as_a_service: 'Yes'
    },
    app_control_profiles: {
      premium_managed_services: 'Yes'
    },
    app_control_execution: {
      premium_managed_services: 'Yes'
    },
    targeted_response_times: {
      premium_managed_services: 'Yes'
    },
    windows_patching: {
      premium_managed_services: 'Yes'
    },
    third_party_patching: {
      premium_managed_services: 'Yes'
    },
    managed_antivirus: {
      premium_managed_services: 'Yes'
    },
    monitoring_alerting: {
      premium_managed_services: 'Yes'
    },
    backup_monitoring: {
      premium_managed_services: 'Yes'
    },
    azure_tenant_management: {
      premium_managed_services: 'Yes'
    },
    office_365_tenant_management: {
      premium_managed_services: 'Yes'
    },
    network_firewall_management: {
      premium_managed_services: 'Yes'
    },
    unlimited_remote_support: {
      premium_managed_services: 'Yes'
    },
    unlimited_onsite_support: {
      premium_managed_services: 'Yes'
    },
    after_hours_support: {
      premium_managed_services: 'Yes'
    },
    email_filtering: {
      premium_managed_services: 'Yes'
    },
    it_documentation: {
      premium_managed_services: 'Yes'
    },
    asset_management: {
      premium_managed_services: 'Yes'
    },
    executive_reporting: {
      premium_managed_services: 'Yes'
    },
    asset_inventory_reporting: {
      premium_managed_services: 'Yes'
    },
    tech_business_review: {
      premium_managed_services: 'Yes'
    },
    dedicated_service_manager: {
      premium_managed_services: 'Yes'
    },
    itsm_service_desk: {
      premium_managed_services: 'Yes'
    },
    regular_onsite_visits: {
      premium_managed_services: 'Yes'
    },
    asset_configuration_management: {
      premium_managed_services: 'Yes'
    },
    change_management: {
      premium_managed_services: 'Yes'
    },
    project_delivery_support: {
      premium_managed_services: 'Yes'
    },
    onpremises_network_management: {
      premium_managed_services: 'Yes'
    },
    firmware_updates: {
      premium_managed_services: 'Yes'
    },
    hardware_support: {
      premium_managed_services: 'Yes'
    },
    software_support: {
      premium_managed_services: 'Yes'
    },
    regular_patch_management: {
      premium_managed_services: 'Yes'
    },
    backup_management: {
      premium_managed_services: 'Yes'
    },
    proactive_security: {
      premium_managed_services: 'Yes'
    },
    antivirus_monitoring: {
      premium_managed_services: 'Yes'
    },
    user_onboard_offboard: {
      premium_managed_services: 'Yes'
    },
    backup_testing_management: {
      premium_managed_services: 'Yes'
    },
    software_licenses: {
      premium_managed_services: 'Yes'
    },
    cloud_platform_management: {
      premium_managed_services: 'Yes'
    },
    shared_drives_management: {
      premium_managed_services: 'Yes'
    },
    proactive_security_advisory: {
      premium_managed_services: 'Yes'
    },
    sophos_mdr_management: {
      premium_managed_services: 'Yes'
    },
    sophos_products_compatible: {
      premium_managed_services: 'Yes',
      soc_essentials: 'Yes',
      soc_complete: 'Yes'
    },
    threat_monitoring_response: {
      soc_essentials: 'Yes',
      soc_complete: 'Yes'
    },
    expert_threat_hunting: {
      soc_essentials: 'Yes',
      soc_complete: 'Yes'
    },
    non_sophos_compatible: {
      soc_essentials: 'Yes',
      soc_complete: 'Yes'
    },
    intelligence_briefings: {
      soc_essentials: 'Yes',
      soc_complete: 'Yes'
    },
    sophos_health_check: {
      soc_essentials: 'Yes',
      soc_complete: 'Yes'
    },
    weekly_monthly_reporting: {
      soc_essentials: 'Yes',
      soc_complete: 'Yes'
    },
    threat_containment: {
      soc_essentials: 'Yes',
      soc_complete: 'Yes'
    },
    reports_service_insights: {
      soc_essentials: 'Yes',
      soc_complete: 'Yes'
    },
    flexible_service_tiers: {
      soc_essentials: 'Yes',
      soc_complete: 'Yes'
    },
    direct_call_support: {
      soc_essentials: 'Yes',
      soc_complete: 'Yes'
    },
    sophos_x_ops_backed: {
      soc_essentials: 'Yes',
      soc_complete: 'Yes'
    },
    full_incident_response: {
      soc_complete: 'Yes'
    },
    breach_protection_warranty: {
      soc_complete: 'Yes'
    },
    root_cause_analysis: {
      soc_complete: 'Yes'
    },
    endpoint_protection_included: {
      soc_complete: 'Yes'
    },
    dedicated_ir_lead: {
      soc_complete: 'Yes'
    },
    sophos_ndr: {
      soc_essentials: 'Yes',
      soc_complete: 'Yes'
    },
    sophos_managed_risk: {
      soc_essentials: 'Yes',
      soc_complete: 'Yes'
    }
  },
  categories: {
    services: ['ASI Services'],
    features: [
      'Security Programs',
      'Assessments', 
      'E8 Services',
      'Application Control',
      'Service Level',
      'Patch Management',
      'Endpoint Protection',
      'Monitoring',
      'Cloud Management',
      'Network Security',
      'Support Services',
      'Email Security',
      'Documentation',
      'Asset Management',
      'Reporting',
      'Business Services',
      'Process Management',
      'Project Services',
      'Network Management',
      'Hardware Support',
      'Software Support',
      'Backup Services',
      'Security Services',
      'User Management',
      'Software Licensing',
      'Data Management',
      'Security Advisory',
      'MDR Services',
      'Infrastructure Support',
      'Professional Services',
      'SOC Services',
      'SOC Complete',
      'Optional Add-ons'
    ]
  }
}; 